module.exports = __webpack_public_path__ + "static/media/logo.50c95690.svg";